import { getServiceBaseURL } from 'APIPackage/MainModule/common/getServiceBaseURL';
import { APIServiceEnum } from 'APIPackage/MainModule/enums/APIServiceEnum';
import { ExportFormatsEnum } from 'APIPackage/ImportExportModule/enums/ExportFormatsEnum';
import { IKnmIndexPage } from 'APIPackage/KnmModule/interfaces/IKnmIndexPage';
import { IExport } from 'APIPackage/ImportExportModule/interfaces/IExport';
import { apiGet, apiPost } from 'APIPackage/MainModule/common/apiTools';

import { IErknmAnalyticsData } from '../interfaces/IErknmAnalyticsData';
import { IErknmAnalyticsFilterRaw } from '../interfaces/IErknmAnalyticsFilterRaw';

export async function fetchErknmAnalytics(
  page: number,
  filter?: IErknmAnalyticsFilterRaw,
  size = 100,
): Promise<IErknmAnalyticsData> {
  const params = new URLSearchParams();

  params.set('page', page.toString());
  params.set('size', size.toString());

  return apiPost<IErknmAnalyticsData>({
    url: `${getServiceBaseURL(APIServiceEnum.ANALYTIC_SERVICE)}/analytics?${params}`,
    body: filter ?? {},
  });
}

export async function fetchErknmAnalyticsExport(
  format: ExportFormatsEnum,
  filter?: IErknmAnalyticsFilterRaw,
): Promise<IExport> {
  const params = new URLSearchParams();

  params.append('format', format);

  return apiPost<IExport>({
    url: `${getServiceBaseURL(APIServiceEnum.ANALYTIC_SERVICE)}/analytics/export?${params}`,
    body: filter ?? {},
  });
}

export async function fetchErknmAnalyticsFilter(): Promise<IErknmAnalyticsFilterRaw> {
  return apiGet<IErknmAnalyticsFilterRaw>(`${getServiceBaseURL(APIServiceEnum.ANALYTIC_SERVICE)}/analytics/filter`);
}

export async function fetchErknmAnalyticsExportKnmList(
  r: string,
  c: string,
  f: string | null,
  format: ExportFormatsEnum,
  filter?: IErknmAnalyticsFilterRaw,
): Promise<IExport> {
  const params = new URLSearchParams();

  params.set('r', r);
  params.set('c', c);
  f && params.set('f', f);
  params.set('format', format);

  return apiPost<IExport>({
    url: `${getServiceBaseURL(APIServiceEnum.ANALYTIC_SERVICE)}/analytics/export/knm?${params}`,
    body: filter ?? {},
  });
}

export async function fetchErknmAnalyticsKnm(
  r: string,
  c: string,
  f: string | null,
  page: number = 0,
  size: number = 50,
  filter?: IErknmAnalyticsFilterRaw,
  order?: string | null,
): Promise<IKnmIndexPage> {
  const params = new URLSearchParams();

  params.set('r', r);
  params.set('c', c);
  f && params.set('f', f);
  params.set('page', page.toString());
  params.set('size', size.toString());
  if (order) {
    params.append('order', order);
  }

  return apiPost<IKnmIndexPage>({
    url: `${getServiceBaseURL(APIServiceEnum.ANALYTIC_SERVICE)}/analytics/knm?${params}`,
    body: filter ?? {},
  });
}
